// gather the .wav files
import LowTom from "./Electronic-Tom-1.wav";
import BassSlap from "./Alesis-S4-Plus-FatSynSlap-C2.wav";
import BassDrum from "./Bass-Drum-1.wav";
import BassSynth from "./Casio-VZ-10M-Fretless-Bass-C2.wav";
import Cowbell from "./Cowbell-1.wav";
import HighQ from "./Korg-N1R-High-Q.wav";
import OpenSurdo from "./Korg-N1R-Open-Surdo.wav";
import PedalHiHat from "./Korg-N1R-Pedal-Hi-Hat.wav";
import VibraSlap from "./Korg-N1R-Vibraslap.wav";

const WaveFiles = {
  LowTom,
  BassSlap,
  BassDrum,
  BassSynth,
  Cowbell,
  HighQ,
  OpenSurdo,
  PedalHiHat,
  VibraSlap
};
export default WaveFiles;
